import styled from "styled-components";

export const SectionTitle = styled.h3`
  font-family: "Lato", sans-serif;
  color: #fff;
`;
